import { LoadingSpinner } from "@/react/components/customer/modal/results/styled";
import TrunkGatewayCard from "./TrunkGatewayCard";
import { useGetSipTrunksQuery } from "../api";
import styled from "styled-components";
import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { customerIdSelector } from "@/react/features/customer/customerSlice";

const SipTrunkList = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
`;

export const TrunkGatewaysList = () => {
  const customerId = useSelector(customerIdSelector);
  const {
    data: sipTrunks,
    isLoading: sipTrunksLoading,
    refetch,
  } = useGetSipTrunksQuery();

  useEffect(() => {
    refetch && refetch();
  }, [customerId]);

  const sortedTrunks = useMemo(
    () => [...(sipTrunks || [])].sort((a, b) => a.name.localeCompare(b.name)),
    [sipTrunks]
  );

  return sipTrunksLoading ? (
    <LoadingSpinner size={36} />
  ) : (
    <SipTrunkList>
      {sortedTrunks.length > 0 ? (
        sortedTrunks.map((trunk, index) => (
          <TrunkGatewayCard
            index={index + 1}
            trunkId={trunk.trunkId}
            name={trunk.name}
            brand={trunk.brand}
            ipBoxes={trunk.boxes?.length}
            outboundIpBoxes={trunk.additionalBoxes?.length}
            proxyServer={trunk.proxyServer}
          />
        ))
      ) : (
        <div>No trunks available.</div>
      )}
    </SipTrunkList>
  );
};
